import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { EyeFilled, HeartFilled } from "@ant-design/icons";
import { PortfolioData } from "../Data/PortfolioData";
import { BlogData } from "../Data/BlogData";
import "../Css/Index.css";
import { CertificatesData } from "../Data/CertificatesData";

const Index = () => {
  return (
    <>
      <Header />
      <div className="slider-container">
        <link
          rel="preload"
          href="/assets/images/home/slider.webp"
          as="image"
          type="image/webp"
        />
        <div className="slider-image">
          <img
            src="/assets/images/home/slider.webp"
            alt="Slider Görseli"
            loading="lazy"
          />
        </div>
        <div className="slider-title-section">
          <div className="slider-main-title">
            <h1>Modern</h1>
          </div>
          <div className="slider-sub-title">
            <h1>Web </h1>
          </div>
          <div className="slider-sub-title">
            <h1> Tasarım </h1>
          </div>
        </div>
        <div className="slider-content-section">
          <p>
            Modern tasarım anlayışımızla, kullanıcı dostu ve estetik açıdan
            başarılı web siteleri oluşturuyoruz. Her projeye özenle yaklaşarak,
            ihtiyaçlarınıza uygun çözümler sunmayı hedefliyoruz.
          </p>
        </div>
      </div>
      <div className="about-container">
        <div className="about-image">
          <img src="/assets/images/home/profil.webp" alt="Profil Resmi" />
        </div>
        <div className="about-content">
          <div className="about-title-text">
            <h1>Hakkımda</h1>
          </div>
          <div className="about-subtitle-section">
            <span>Volkan Kıyçak</span>
          </div>
          <div className="about-main-content">
            <p>
              Merhaba, ben Volkan Kıyçak. Trakya Üniversitesi Bilgisayar
              Programcılığı bölümünden mezunum ve front-end ile back-end
              geliştirme teknolojilerinde yetkinim. React.js ve ASP.NET Core
              MVC/Web API gibi teknolojilerle kullanıcı dostu ve verimli web
              uygulamaları geliştirmeye tutkuluyum.
            </p>
            <p>
              Eğitim sürecim, teknolojiye olan tutkumun artmasına ve problem
              çözme becerilerimin gelişmesine olanak tanıdı. Şu anda, hem
              front-end hem de back-end geliştirme projelerinde deneyim
              kazanarak teknik bilgi ve yeteneklerimi sürekli olarak
              geliştirmeye devam ediyorum.
            </p>
            <p>
              Daha fazla bilgi ve projelerim hakkında detaylı bilgi almak
              isterseniz, <a href="/About">Hakkımda</a> sayfama göz
              atabilirsiniz.
            </p>
          </div>
        </div>
      </div>
      <div className="portfolio-container">
        <div className="portfolio-title">
          <h1>Çalışmalarım</h1>
        </div>
        <div className="portfolio-item">
          {PortfolioData.slice(0, 4).map((product) => (
            <div className="portfolio">
              <a
                href={"/PortfolioDetail/" + product.id}
                className="portfolio-link"
                aria-label="Portföy detayı"
              >
                <img src={product.image} alt="" className="portfolio-image" />
              </a>
              <div className="portfolio-wrapper">
                <a
                  href={"/PortfolioDetail/" + product.id}
                  className="portfolio-wrapper-link"
                >
                  <div className="portfolio-details">
                    <strong className="portfolio-name">{product.title}</strong>
                    <span className="portfolio-category">Web Site</span>
                  </div>
                </a>
                <div className="portfolio-icons-container">
                  <div className="portfolio-icons-heart">
                    <span className="portfolio-icons-heart-link">
                      <HeartFilled
                        onTouchStart={(e) => e.preventDefault()}
                        className="portfolio-icon"
                      />
                    </span>
                    <span className="portfolio-icon-text">1</span>
                  </div>
                  <div className="portfolio-icons-eye">
                    <EyeFilled className="portfolio-icon" />
                    <span className="portfolio-icon-text">1</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="portfolio-list-content-container">
          <div className="portfolio-list-container">
            <a href={"/Portfolio"} className="portfolio-list-link">
              <strong className="portfolio-list-text">Tümünü listele</strong>
            </a>
          </div>
        </div>
      </div>
      <div className="certificates-container">
        <div className="certificates-title">
          <h1>Sertifikalarım</h1>
        </div>
        <div className="certificates-item">
          {CertificatesData.slice(0, 4).map((product) => (
            <div className="certificates">
              <a
                href={product.file}
                target="_blank"
                rel="noopener noreferrer"
                className="certificates-link"
              >
                <img
                  src={product.image}
                  alt={product.title}
                  className="certificates-image"
                />
              </a>
              <div className="certificates-wrapper">
                <a
                  href={product.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="certificates-wrapper-link"
                >
                  <div className="certificates-details">
                    <strong className="certificates-name">
                      {product.title}
                    </strong>
                    <span className="certificates-category">
                      {product.date}
                    </span>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="certificates-list-content-container">
          <div className="certificates-list-container">
            <a href={"/Certificates"} className="certificates-list-link">
              <strong className="certificates-list-text">Tümünü listele</strong>
            </a>
          </div>
        </div>
      </div>
      <div className="blog">
        <div className="blog-title">
          <h1>Blog</h1>
        </div>
        <div className="blog-post">
          {BlogData.slice(0, 6).map((product) => (
            <a href={"/BlogDetail/" + product.id} className="blog-post-link">
              <div className="blog-post-image">
                <img src={product.image} alt="" />
              </div>
              <div className="blog-post-content">
                <strong>{product.title}</strong>
                <br />
                <p className="p1">Volkan Kıyçak - {product.history}</p>
                <p className="p2">{product.content}</p>
                <p className="p3">{product.label}</p>
              </div>
            </a>
          ))}
        </div>
        <div className="blog-list-content-container">
          <div className="blog-list-container">
            <a href={"/Blog"} className="blog-list-link">
              <strong className="blog-list-text">Tümünü listele</strong>
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Index;
